import { render, staticRenderFns } from "./RoundTickets.vue?vue&type=template&id=4872666a&"
import script from "./RoundTickets.vue?vue&type=script&lang=js&"
export * from "./RoundTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports